import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
// import 'es6-promise/auto';
import layout from "./modules/layout";
import menu from "./modules/menu";
import { auth } from "./modules/authentication";
import { pengguna } from "./modules/pengguna";
import { dashboard } from "./modules/dashboard";
import { configuration } from "./modules/configuration";

import { service } from "./modules/service";
import { masterParoki } from "./modules/masterParoki";
import { masterWilayah } from "./modules/masterWilayah";
import { masterStasi } from "./modules/masterStasi";

import { umat } from "./modules/umat";
import { umatBaptis } from "./modules/umatBaptis";
import { umatKomuni } from "./modules/umatKomuni";
import { umatKrisma } from "./modules/umatKrisma";
import { umatPerkawinan } from "./modules/umatPerkawinan";
import { umatKematian } from "./modules/umatKematian";
import { keluargaKatolik } from "./modules/keluargaKatolik";
import { umatArsip } from "./modules/umatArsip";

import { iuran } from "./modules/iuran";

import { laporan } from "./modules/laporan";
import { log } from "./modules/log";

import { landing } from "./modules/landing";

Vue.use(Vuex);

export const store = new Vuex.Store({
   state: {
      isLoading: false,
   },
   mutations: {},
   actions: {},
   modules: {
      layout,
      menu,
      auth,
      pengguna,
      dashboard,
      service,
      configuration,

      umat,
      umatBaptis,
      umatKomuni,
      umatKrisma,
      umatPerkawinan,
      umatKematian,
      keluargaKatolik,
      umatArsip,

      iuran,

      masterParoki,
      masterWilayah,
      masterStasi,

      laporan,
      log,

      landing,
   },
   plugins: [
      createPersistedState({
         paths: ["service"],
      }),
   ],
   // plugins: [createPersistedState()],
});
